import { WarningTwoTone } from "@ant-design/icons";
import { Tooltip } from "antd";
import AttachmentCell from "components/atoms/AttachmentCell";
import EmailVerificationBadge from "components/atoms/EmailVerificationBadge";
import FormDateDisplayField from "../FormDateDisplayField";
import FormDateTimeDisplayField from "../FormDateTimeDisplayField";
import FormEmailDisplayField from "../FormEmailDisplayField";
import FormPhoneDisplayField from "../FormPhoneDisplayField";
import FormTimeDisplayField from "../FormTimeDisplayField";

/** @type {import('./types').IFormDisplayField} */
const FormDisplayField = ({ fieldError, dataType, value, verificationResult, disabled = false, ...props }) => {
    let fieldComponent;
    if (!fieldError) {
        switch (dataType) {
            case "email":
                fieldComponent = <FormEmailDisplayField value={value} />;
                break;
            case "datetime":
                fieldComponent = <FormDateTimeDisplayField dataType={dataType} value={value} disabled={disabled} {...props} />;
                break;
            case "date":
                fieldComponent = <FormDateDisplayField dataType={dataType} value={value} disabled={disabled} {...props} />;
                break;
            case "time":
                fieldComponent = <FormTimeDisplayField dataType={dataType} value={value} disabled={disabled} {...props} />;
                break;
            case "phone":
                fieldComponent = <FormPhoneDisplayField dataType={dataType} value={value} disabled={disabled} {...props} />;
                break;
            case "attachment":
            case "image":
            case "document":
                fieldComponent = <AttachmentCell dataType={dataType} value={value} disabled={disabled} {...props} />;
                break;
            default:
                fieldComponent = <>{value}</>;
                break;
        }
    }
    return (
        <>
            {fieldError ? (
                <Tooltip placement="topLeft" title={fieldError}>
                    <WarningTwoTone twoToneColor="#FF0000" className="mr-1" />
                    {value !== null && value !== undefined && value !== "" ? <span>{value}</span> : <span className="italic text-gray-500">empty</span>}
                </Tooltip>
            ) : (
                <></>
            )}{" "}
            {fieldComponent}
            {dataType === "email" && <EmailVerificationBadge verificationResult={verificationResult} />}
        </>
    );
};

export default FormDisplayField;
